import { useEffect, useState } from 'react';

import { useExecuteQuery } from '@sisense/sdk-ui';

import * as DM from '../../../../usas-times-data';
import { filterFactory } from '@sisense/sdk-data';

const useSisenseScmEventNoCourseDropdown = () => {
    const queryProps = {
        dataSource: DM.DataSource, dimensions: [DM.SwimEvent.SwimEventKey, DM.SwimEvent.EventCode],
        filters: [filterFactory.contains(DM.SwimEvent.EventCode, 'SCM')]
    };
    const { data, isLoading } = useExecuteQuery(queryProps);
    const [scmEventNoCourseOptions, setScmEventNoCourseOptions] = useState({ options: [] });

    useEffect(() => {
        const defaultOptions = [];
        if (data) {
            const formattedOptions = [];
            data.rows.map((row) => {
                if (row[0].data !== 0) {
                    return (formattedOptions.push({ id: row[0].data, name: row[1].text }));
                }
            });
            setScmEventNoCourseOptions({ ...scmEventNoCourseOptions, options: formattedOptions });
        }
        else {
            setScmEventNoCourseOptions({ ...scmEventNoCourseOptions, options: defaultOptions });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    return {
        data,
        isLoading,
        scmEventNoCourseOptions
    };
};

export default useSisenseScmEventNoCourseDropdown; 